import React from 'react';
import classNames from 'classnames';
import './skeleton.less';

const VARIANT = {
    TEXT: 'text',
    RECT: 'rect',
    CIRCLE: 'circle'
};

/**
 * Prop types are declared here rather than inferred from destructuring defaults:
 * TypeScript reads JSDoc from .jsx files, and a `= undefined` default would
 * otherwise narrow a prop to the literal `undefined` and reject every real value
 * a .tsx caller passes.
 *
 * @param {{
 *   variant?: string,
 *   width?: string | number,
 *   height?: string | number,
 *   className?: string,
 *   style?: React.CSSProperties,
 *   isAnimated?: boolean
 * }} props
 */
export function Skeleton({
    variant = VARIANT.RECT,
    width,
    height,
    className,
    style,
    isAnimated = true
}) {
    const rootClassName = classNames('vs-skeleton', `is-${variant}`, className, {
        'is-static': !isAnimated
    });

    const inlineStyle = {
        width,
        height,
        ...style
    };

    return <span className={rootClassName} style={inlineStyle} aria-hidden="true" />;
}

/**
 * @param {{lines?: number, className?: string, lastLineWidth?: string | number}} props
 */
export function SkeletonText({lines = 3, className, lastLineWidth = '60%'}) {
    return (
        <div className={classNames('vs-skeleton-text', className)}>
            {Array.from({length: lines}).map((_, index) => (
                <Skeleton
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    variant={VARIANT.TEXT}
                    width={index === lines - 1 ? lastLineWidth : '100%'}
                />
            ))}
        </div>
    );
}

Skeleton.VARIANT = VARIANT;
